import { render, staticRenderFns } from "./UploadBookEntriesDoc.vue?vue&type=template&id=127cc632&scoped=true&"
import script from "./UploadBookEntriesDoc.vue?vue&type=script&lang=js&"
export * from "./UploadBookEntriesDoc.vue?vue&type=script&lang=js&"
import style0 from "./UploadBookEntriesDoc.vue?vue&type=style&index=0&id=127cc632&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127cc632",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VSpacer})
